import {api, authApi} from "./AuthApiClient";


export async function getNews(page, size) {
    try {
        return await api.get("/v1/news", {params: {page, size}});
    } catch (error) {
        return [];
    }
}

export async function createNews( file, title, author, text, eventDate ) {
    const formData = new FormData();

    if (file) {
        formData.append("file", file);
    }

    if (!author || author.length === 0) {
        author = 'Admin'
    }

    const json = JSON.stringify({
        title: title,
        author: author,
        text: text,
        event_date: eventDate
    });

    formData.append("json", new Blob([json], { type: "application/json" }));

    return await authApi.post("/v1/news", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

export async function updatePhotoNews(photo, newsId) {
    const formData = new FormData();
    formData.append("file", photo);
    const json = JSON.stringify({
        id: newsId
    })
    formData.append("json", new Blob([json], { type: "application/json" }));

    return await authApi.patch("/v1/news/photo", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

export async function deleteNews(newsId) {
    return await authApi.delete("/v1/news",{
        data: {
            id: newsId
        }
    })
}

export async function updateNews(newsId, title, author, text, eventDate) {
    const resultDate = new Date(eventDate.getTime() + 3 * 60 * 60 * 1000);
    return await authApi.patch("/v1/news",{
        id: newsId,
        title: title,
        author: author,
        text: text,
        event_date: resultDate
    })
}
